module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
  siteTitle: "Julien Isoré - Forest is art", // Navigation and Site Title
  siteTitleAlt: "Julien Isoré - Forest is art", // Alternative Site title for SEO
  siteUrl: 'https://julienisore.com', // Domain of your site. No trailing slash!
  siteEmail: 'julien.isore@gmail.com',
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: '/logoGris.png', // Used for SEO and manifest
  siteDescription: 'Julien Isoré - Forest is art',
  siteTel:'',
  author:'Olivier Genevest',
   authorUrl:'https://oliviergenevest.info/',
   publisher:'Julien Isoré',
    shareImage: '/images/alan-tod-icon.png', // Open Graph Default Share Image. 1200x1200 is recommended
  //siteFBAppID: '123456789', // Facebook App ID
  facebookPageUrl:'https://www.facebook.com/julien.isore.7/',
  instagramPageUrl:'https://www.instagram.com/julien_isore',
  //userTwitter: '@emma', // Twitter Username
  // og: Meta Tags
  ogSiteName: 'Julien Isoré - Forest is art', // Facebook Site Name
  ogLanguage: 'en_EN',
  googleAnalyticsID: '',
  
  // Date format used in your project header
  // More information here: https://date-fns.org/v1.29.0/docs/format
  dateFormat: 'DD.MM.YYYY',
  // Manifest and Progress color
  themeColor: '#4a4a4a',
  backgroundColor: '#7F868A',
   

  locales: {
    en: {
      path: 'en',
      locale: 'English',
      default: true
    },
    fr: {
      path: 'fr',
      locale: 'Français'
    }
  },

};
